namespace $.$$ {
	export class $shm_hitalama_guide_panel extends $.$shm_hitalama_guide_panel {
		catalog() { return this.$.$shm_hitalama_guide_catalog.current()! }
		trail() { return ( this.$.$mol_state_arg.value( this.param() ) || this.catalog()?.root( this.section() ) || 'start' ).split( ',' ).slice( -40 ) }
		selected() { return this.trail().at( -1 )! }
		document() { return this.catalog()?.page( this.selected() )?.read() ?? null }
		title() { return this.document()?.title ?? 'Руководство пользователя' }
		text() { const page = this.document(); return page ? this.$.$shm_hitalama_guide_markdown.text( page ) : 'Руководство ещё не опубликовано.' }
		editable() { return this.catalog()?.page( this.selected() )?.can_change() ?? false }
		@ $mol_mem
		editing_id( next = '' ) { return next }
		editing( next?: boolean ) { if( next !== undefined ) this.editing_id( next ? this.selected() : '' ); return this.editing_id() === this.selected() }
		guide_pages() { return [ this.Page(), ...( this.editing() ? [ this.Editor() ] : [] ) ] }
		breadcrumbs() { return this.trail().flatMap( ( id, index )=> index ? [ ' / ', this.Crumb( index ) ] : [ this.Crumb( index ) ] ) }
		heading() { return this.trail().length > 1 ? this.breadcrumbs() : [this.Header_label()] }
		crumb_title( index: number ) { return this.catalog()?.page( this.trail()[index] )?.read().title ?? this.trail()[index] }
		crumb_arg( index: number ) { return { [ this.param() ]: this.trail().slice( 0, index + 1 ).join( ',' ) } }
		page_uri( id: string ) {
			const trail = this.trail(), found = trail.indexOf(id)
			return this.$.$mol_state_arg.link({ [this.param()]: (found<0 ? [...trail,id] : trail.slice(0,found+1)).join(',') })
		}
		@ $mol_action
		close( event?: Event ) { if( event ) this.$.$mol_state_arg.value( 'help', 'off' ); return null }
	}
}
